var _style, _g, _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavesPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:none;clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st2{display:none;opacity:0.2;clip-path:url(#SVGID_2_);fill:url(#SVGID_4_);}\n\t.st3{display:none;opacity:0.2;clip-path:url(#SVGID_2_);fill:url(#SVGID_5_);}\n\t.st4{display:none;opacity:0.2;clip-path:url(#SVGID_2_);fill:url(#SVGID_6_);}\n\t.st5{display:none;opacity:0.2;clip-path:url(#SVGID_2_);fill:url(#SVGID_7_);}\n\t.st6{display:none;clip-path:url(#SVGID_2_);fill:#F8E6CB;}\n\t.st7{display:none;clip-path:url(#SVGID_2_);fill:url(#SVGID_8_);}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{fill:none;stroke:#D8D8D8;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 375,
    y1: 0,
    x2: 375,
    y2: 500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3DBDB"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.6613,
    y1: 466.9291,
    x2: 732.2383,
    y2: 466.9291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D5DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M682.48,545.29c-7.53-21.62-5.46-45.36-1.48-67.9c3.98-22.55,9.8-45,9.5-67.9    c-0.5-37.39-18.42-74.23-47.68-97.51C613.56,288.7,573.5,279.53,537.08,288c-23.03,5.36-44.68,17.34-68.31,18.31    c-24.26,1-47.31-9.72-71.19-14.1c-56.7-10.41-117.47,18.12-149.2,66.25c-31.73,48.13-34.74,112.69-11.52,165.46    s70.82,93.23,125.34,111.98c54.51,18.74,115.18,16.57,169.87-1.66c26.82-8.94,52.35-21.59,79.54-29.3    c27.2-7.71,57.23-10.12,83.08,1.32l37.54-19.83C709.35,585.81,690.02,566.91,682.48,545.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -227.9816,
    y1: 595.418,
    x2: 282.5954,
    y2: 595.418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D5DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDB"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.84,673.78c-7.54-21.62-5.46-45.36-1.48-67.9c3.98-22.55,9.8-45,9.5-67.9    c-0.5-37.39-18.42-74.23-47.68-97.51c-29.26-23.28-69.32-32.45-105.74-23.98c-23.03,5.36-44.68,17.34-68.31,18.31    c-24.26,1-47.31-9.72-71.19-14.1c-56.7-10.41-117.47,18.12-149.2,66.25c-31.73,48.13-34.74,112.69-11.52,165.46    c23.22,52.76,70.82,93.23,125.34,111.98c54.51,18.74,115.18,16.57,169.87-1.66c26.82-8.94,52.35-21.59,79.54-29.3    c27.2-7.71,57.23-10.12,83.08,1.32l37.54-19.83C259.71,714.3,240.37,695.4,232.84,673.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.9715,
    y1: -86.7707,
    x2: 902.5485,
    y2: -86.7707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D5DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M852.79-8.4c-7.54-21.62-5.46-45.36-1.48-67.9c3.98-22.55,9.8-45,9.5-67.9    c-0.5-37.39-18.42-74.23-47.68-97.51s-69.32-32.45-105.74-23.98c-23.03,5.36-44.68,17.34-68.31,18.31    c-24.26,1-47.31-9.72-71.19-14.1c-56.7-10.41-117.47,18.12-149.2,66.25c-31.73,48.13-34.74,112.69-11.52,165.46    C430.4,22.98,478,63.45,532.51,82.19c54.51,18.74,115.18,16.57,169.87-1.66c26.82-8.94,52.35-21.59,79.54-29.3    c27.2-7.71,57.23-10.12,83.08,1.32l37.54-19.83C879.66,32.11,860.33,13.21,852.79-8.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 95.2595,
    x2: 495.82,
    y2: 95.2595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D5DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDB"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M495.82,0c-4.25,25.2-14.46,49.39-30.15,69.59c-30.96,39.84-82.29,62.95-132.64,59.7    c-5.35-0.34-10.74-0.95-16.15-1.68c-28.28-3.79-57.1-10.7-82.47,1.11c-21.54,10.03-35.31,31.55-54.75,45.2    c-25.43,17.86-59.66,20.78-89.24,11.25c-29.57-9.53-54.63-30.45-72.94-55.56C11.15,120.93,5.55,111.74,0,102.5V0H495.82z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M609.23,0c-6.27,5.83-13.53,10.55-21.62,13.67c-14.61,5.65-31.08,6.74-44.34,15.07    c-17.47,10.97-25.59,32.06-29.99,52.21c-4.39,20.16-6.39,41.34-16.32,59.42c-20.58,37.51-71.75,50.41-112.32,36.81    c-27.01-9.06-49.57-27.32-67.76-49.57c-9.12-11.16-17.14-23.31-24.06-35.81c-15.64-28.25-27.11-59.36-48.56-83.49    c-2.58-2.91-5.38-5.69-8.34-8.31H609.23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M750,245.8v254.2H384.18c1.23-10.72,3.48-21.32,6.86-31.64c11.41-34.93,36.16-65.52,67.54-84.24    c16.58-9.9,35.02-16.49,54.32-18.64c25.13-2.81,53.46,0.58,72.83-15.67c11.65-9.78,17.31-24.71,24.57-38.08    c20.68-38.04,59.63-67.16,102.82-70.22C725.51,240.63,738.07,242.18,750,245.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.33,
    y1: 429.0495,
    x2: 647.26,
    y2: 429.0495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1D5DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DBDBDB"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M647.26,500.01H161.33c1.46-13.7,4.91-27.24,9.92-40.06c11.72-29.92,35.16-58.44,66.97-62.98    c13.72-1.96,27.2,0.7,40.25,5.54c18.7,6.93,39.65,1.28,52.48-13.99c9.06-10.77,20.71-19.39,33.8-24.57    c24.24-9.61,52.9-7.26,75.25,6.15c6.63,3.98,12.71,8.85,18.58,14.03c16.7,14.72,31.71,31.94,52.74,38.34    c21.87,6.64,45.77-0.03,68.18,4.45c32.85,6.57,56.99,36.54,66.53,68.65C646.47,497.04,646.88,498.52,647.26,500.01z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2206 -0.9754 0.9754 0.2206 0.3458 312.0384)",
    className: "st6",
    cx: 195.41,
    cy: 155.8,
    rx: 34.08,
    ry: 34.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7489 -0.6627 0.6627 0.7489 -21.5979 461.0347)",
    className: "st6",
    cx: 597.53,
    cy: 259.02,
    rx: 11.7,
    ry: 11.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.38,396.53c0,3.23-2.62,5.85-5.85,5.85s-5.85-2.62-5.85-5.85c0-3.23,2.62-5.85,5.85-5.85    S103.38,393.3,103.38,396.53z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M658.96,213.59c0,3.23-2.62,5.85-5.85,5.85c-3.23,0-5.85-2.62-5.85-5.85c0-3.23,2.62-5.85,5.85-5.85    C656.34,207.74,658.96,210.36,658.96,213.59z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M88.7-12.16c41.56-0.05,82.76,19.09,109.53,50.89c23.21,27.58,35.17,62.8,55.08,92.84     c19.91,30.05,53.54,56.4,88.98,49.8c24.33-4.53,43.67-23.94,55.11-45.88c11.44-21.95,16.4-46.57,22.52-70.55     c6.13-23.98,13.91-48.32,29.76-67.33c20.1-24.09,52.73-37.09,83.89-33.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.62-13.68c38.96-0.05,77.58,17.9,102.68,47.7c21.76,25.85,32.97,58.87,51.63,87.03     c18.67,28.17,50.19,52.87,83.41,46.68c22.81-4.25,40.94-22.44,51.66-43.01c10.73-20.57,15.37-43.66,21.11-66.14     c5.74-22.48,13.04-45.3,27.9-63.11c18.84-22.58,49.43-34.77,78.64-31.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.54-15.2c36.36-0.04,72.41,16.7,95.82,44.52c20.31,24.12,30.77,54.94,48.19,81.22     c17.42,26.29,46.84,49.34,77.84,43.56c21.29-3.96,38.2-20.94,48.21-40.14c10.01-19.2,14.34-40.74,19.7-61.72     c5.36-20.98,12.17-42.27,26.04-58.9c17.58-21.07,46.13-32.45,73.39-29.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.46-16.72c33.76-0.04,67.23,15.51,88.97,41.33c18.85,22.4,28.57,51.01,44.74,75.41     s43.49,45.81,72.27,40.45c19.76-3.68,35.47-19.44,44.76-37.27c9.29-17.82,13.32-37.83,18.29-57.3     c4.98-19.48,11.3-39.25,24.18-54.69C440-28.34,466.5-38.9,491.81-35.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M144.38-18.23c31.16-0.04,62.05,14.31,82.11,38.15c17.4,20.67,26.36,47.08,41.29,69.6     c14.93,22.52,40.14,42.28,66.7,37.33c18.24-3.4,32.74-17.94,41.31-34.4c8.58-16.45,12.29-34.91,16.88-52.89     c4.59-17.98,10.43-36.23,22.31-50.47c15.07-18.06,39.53-27.81,62.89-25.06"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M306.01,572.54c-6.88-25.1-11.89-52.45-2.28-76.63c12.6-31.68,47.55-49.43,81.4-53.49     c33.85-4.07,67.94,2.65,101.94,5.24c34,2.58,70.41,0.35,98.44-19.08c38.86-26.94,51.62-79.44,86.69-111.17     c29.24-26.45,73.38-35.18,110.49-21.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M331.76,572.54c-6.51-23.74-11.25-49.62-2.16-72.49c11.92-29.97,44.98-46.76,77-50.6     c32.03-3.85,64.27,2.51,96.43,4.96c32.16,2.45,66.61,0.33,93.12-18.05c36.77-25.49,48.83-75.15,82.01-105.16     c27.66-25.02,69.42-33.28,104.52-20.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M357.51,572.54c-6.13-22.39-10.61-46.78-2.03-68.35c11.24-28.26,42.41-44.09,72.61-47.71     c30.2-3.63,60.6,2.37,90.93,4.67c30.33,2.31,62.81,0.31,87.8-17.02c34.67-24.03,46.04-70.86,77.32-99.16     c26.08-23.6,65.45-31.38,98.55-19.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M383.26,572.54c-5.76-21.03-9.97-43.95-1.91-64.21c10.56-26.55,39.84-41.42,68.21-44.82     c28.37-3.41,56.93,2.22,85.42,4.39c28.49,2.17,59,0.29,82.48-15.99c32.57-22.57,43.25-66.57,72.64-93.15     c24.5-22.17,61.49-29.48,92.58-18.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M409.01,572.54c-5.39-19.68-9.32-41.12-1.79-60.07c9.87-24.84,37.27-38.75,63.81-41.93     c26.54-3.19,53.26,2.08,79.91,4.11c26.65,2.03,55.2,0.27,77.17-14.96c30.47-21.12,40.47-62.28,67.96-87.15     c22.92-20.74,57.53-27.58,86.61-17.11"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-7.43,199.63c-5.02,17.48,3.92,36.38,16.88,49.14c12.96,12.76,29.55,21.02,44.8,30.94     c15.25,9.92,29.99,22.57,35.76,39.82c10.26,30.69-10.69,61.93-20.68,92.71c-15.12,46.57-3.34,100.87,29.72,136.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-19.29,203.24c-5.02,17.48,3.92,36.38,16.88,49.14c12.96,12.76,29.55,21.02,44.8,30.94     c15.25,9.92,29.99,22.57,35.76,39.82c10.26,30.69-10.69,61.93-20.68,92.71c-15.12,46.57-3.34,100.87,29.72,136.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-31.16,206.85c-5.02,17.48,3.92,36.38,16.88,49.14c12.96,12.76,29.55,21.02,44.8,30.94     c15.25,9.92,29.99,22.57,35.76,39.82c10.26,30.69-10.69,61.93-20.68,92.71c-15.12,46.57-3.34,100.87,29.72,136.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-43.02,210.46c-5.02,17.48,3.92,36.38,16.88,49.14c12.96,12.76,29.55,21.02,44.8,30.94     c15.25,9.92,29.99,22.57,35.76,39.82c10.26,30.69-10.69,61.93-20.68,92.71c-15.12,46.57-3.34,100.87,29.72,136.99"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M575.83-186.86c2.54,18.01,18.4,31.63,35.44,38c17.04,6.37,35.55,7.16,53.52,10     c17.97,2.85,36.58,8.4,48.88,21.8c21.88,23.85,15.47,60.91,18.88,93.09c5.17,48.69,38.05,93.48,82.95,113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M566.47-178.73c2.54,18.01,18.4,31.63,35.44,38c17.04,6.37,35.55,7.16,53.52,10     c17.97,2.85,36.58,8.4,48.88,21.8c21.88,23.85,15.47,60.91,18.88,93.09c5.17,48.69,38.05,93.48,82.95,113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M557.11-170.6c2.54,18.01,18.4,31.63,35.44,38c17.04,6.37,35.55,7.16,53.52,10     c17.97,2.85,36.58,8.4,48.88,21.8c21.88,23.85,15.47,60.91,18.88,93.09c5.17,48.69,38.05,93.48,82.95,113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M547.74-162.47c2.54,18.01,18.4,31.63,35.44,38c17.04,6.37,35.55,7.16,53.52,10     c17.97,2.85,36.58,8.4,48.88,21.8c21.88,23.85,15.47,60.91,18.88,93.09c5.17,48.69,38.05,93.48,82.95,113"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesPattern);
export default __webpack_public_path__ + "static/media/wavesPattern.ce4b64c94a22bd13cd9097d7d4964d88.svg";
export { ForwardRef as ReactComponent };